import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getInventoryList } from 'components/inventory/InventoryAPI';
import { setInventoryList, setInventoryDashboardInventoryList } from 'store/slice/ManufSlice';

import { openDrawer } from './../../../store/slice/MenuSlice';
import InventoryDashboard from 'components/inventory/InventoryDashboard';

export default function InventoryPageImpl() {
    const dispatch = useDispatch();
    const { inventoryList} = useSelector((state)=>state.manufslice);
    
    const getInventoryListSuccess = (list) =>{dispatch(setInventoryList(list));}
    useEffect(() => {
       // dispatch(openDrawer(false));
        getInventoryList(()=>{}, getInventoryListSuccess);
    },[]);
    useEffect(()=>{
        setInventoryDashboardInventoryList( inventoryList);
    },[ inventoryList])

    return (
        < InventoryDashboard />
    )

}